import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../auth';

const navItems = [
  { path: '/companies', label: 'Companies' },
  { path: '/users', label: 'Users' },
  { path: '/layout', label: 'Portal Layout' },
  { path: '/popups', label: 'Popups' },
  { path: '/communications', label: 'Communications' },
  { path: '/sharepoint', label: 'SharePoint' },
];

export function AdminLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <div className="admin-header__brand">
          <img src="/get-for-me-color-dark.svg" alt="GET for Me" style={{ height: '28px', width: 'auto' }} />
          <span style={{ fontWeight: 400, fontSize: '0.875rem', color: 'var(--get-gray-600)' }}>
            Admin
          </span>
        </div>
        <div className="admin-header__user">
          <span>{user?.name ?? 'Admin'}</span>
          <button className="btn btn-secondary" onClick={() => logout()}>
            Logout
          </button>
        </div>
      </header>

      <nav className="admin-sidebar" aria-label="Admin navigation">
        <ul className="admin-sidebar__nav">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `admin-sidebar__link${isActive ? ' admin-sidebar__link--active' : ''}`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
